import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ShowreelModal } from "./components/ShowreelModal";
import { BeforeAfter } from "./components/BeforeAfter";
import { Portfolio } from "./components/Portfolio";
import { Services } from "./components/Services";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { AuthCallback } from "./components/AuthCallback";
import { Admin } from "./components/Admin";

const Site = () => {
  const [reelOpen, setReelOpen] = useState(false);

  useEffect(() => {
    const els = document.querySelectorAll("section");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((en) => en.isIntersecting && en.target.classList.add("revealed")),
      { threshold: 0.08 }
    );
    els.forEach((el) => { el.classList.add("reveal"); obs.observe(el); });
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <Navbar onShowreel={() => setReelOpen(true)} />
      <Hero onShowreel={() => setReelOpen(true)} />
      <BeforeAfter />
      <Portfolio />
      <Services />
      <About />
      <Contact />
      <Footer />
      <ShowreelModal open={reelOpen} onClose={() => setReelOpen(false)} />
    </>
  );
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Site />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App grain" data-testid="app-root">
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
